module.exports = __webpack_public_path__ + "img/icon-empty-state-challenges.6eabaaa6.svg";